<template>
  <!-- 个人中心 -->
  <div style="background:#eee">
    <van-nav-bar title="个人中心" left-text="返回" left-arrow @click-left="goback" />
    <div style="height:7.4rem;display:block;background:#1989fa;color: #fff;">
      <div style="display:flex;padding:0.8rem 1.2rem;align-items:center;">
        <van-image round width="6rem" height="6rem" :src="require('./touxiang.png')" />
        <div style="font-size:1.2rem;margin-left:1.2rem;text-align: left">
          <span>{{ userName }}</span><br>
          <div v-show="isShowReceivingOrder()">
            <van-tag type="success" v-show="receivingOrder == 0">接单中</van-tag>
            <van-tag type="danger" v-show="receivingOrder == 1">暂不接单</van-tag>
          </div>
          <span style="font-size:0.5rem">
            当前角色:<span style="color: red">{{ roleName }}</span>
          </span>
        </div>
      </div>
    </div>
    <van-cell-group v-for="section in orderSections" :key="section.orderType" :class="['home-order-section', 'home-order-section-' + section.orderType]" v-show="authorization('/order-data-manage')">
      <van-cell is-link :value="section.linkText" @click="goOrderList(-1, section.orderType)">
        <template #title><span class="home-order-title"><span>{{ section.title }}</span><span class="home-order-count">{{ section.count }}</span></span></template>
      </van-cell>
      <van-row>
        <van-col span="8" style="padding:1rem 0;" v-for="(itme, index) in section.items" :key="index"
          @click="goOrderList(itme.type, section.orderType)">
          <van-icon v-show="itme.num > 0" style="font-size:1.6rem;padding-bottom:0.2rem;" :name="itme.icon"
            :color="itme.color" :badge="itme.num" />
          <van-icon v-show="itme.num <= 0" style="font-size:1.6rem;padding-bottom:0.2rem;" :name="itme.icon"
            :color="itme.color" />
          <br>
          <span style="font-size:0.8rem">{{ itme.title }}</span>
        </van-col>
      </van-row>
    </van-cell-group>
    <div v-show="authorization('/order-data-manage')" class="home-order-divider"></div>
    <van-cell-group class="home-order-section" v-show="authorization('/home-admin/settlementManage/h5')">
      <van-cell title="结算管理" style="padding:0.6rem;text-align:left" />
      <van-row>
        <van-col span="8" style="padding:1rem 0;" v-for="(item, index) in settlementList" v-show="item.isHidden" :key="index" @click="goSettlementList(item.url,item.type)">
          <van-icon v-show="item.num > 0" style="font-size:1.6rem;padding-bottom:0.2rem;" :name="item.icon"
            :color="item.color" :badge="item.num" />
          <van-icon v-show="item.num <= 0" style="font-size:1.6rem;padding-bottom:0.2rem;" :name="item.icon"
            :color="item.color" />  
            <br>
            <span style="font-size:0.8rem">{{ item.title }}</span>
        </van-col>
      </van-row> 
    </van-cell-group>
    <div v-show="authorization('/home-admin/settlementManage/h5')" class="home-order-divider"></div>
    <van-cell-group class="home-order-section">
      <van-cell title="管理中心" style="padding:0.6rem;text-align:left" />
      <van-row>
        <!--  -->
        <van-col span="8" style="padding:1rem 0;" v-for="(itme, index) in mamageList" v-show="!itme.isHidden" :key="index"
          @click="goMamageList(itme.type)">
          <van-icon style="display: block;font-size:1.6rem;padding-bottom:0.2rem;" :name="itme.icon"
            :color="itme.color" />
          <span style="font-size:0.8rem">{{ itme.title }}</span>
        </van-col>
        <!--        <van-col v-show="isShowReceivingOrder()" span="8" style="padding:1rem 0;" @click="isSetReceiving">-->
        <!--          <van-icon style="display: block;font-size:1.6rem;padding-bottom:0.2rem;" name="service-o" color="#00e500"/>-->
        <!--          <span style="font-size:0.8rem" v-show="receivingOrder==0">暂不接单</span>-->
        <!--          <span style="font-size:0.8rem" v-show="receivingOrder==1">正常接单</span>-->
        <!--        </van-col>-->
        <van-col span="8" style="padding:1rem 0;" @click="loginOut">
          <van-icon style="display: block;font-size:1.6rem;padding-bottom:0.2rem;" name="friends-o"
            color="rgb(145, 141, 148)" />
          <span style="font-size:0.8rem">退出登录</span>
        </van-col>
        <van-col span="8" style="padding:1.2rem;" @click="showPwd = true">
          <van-icon style="display: block;font-size:1.6rem;padding-bottom:0.2rem;" name="edit" color="#f00" />
          <span style="font-size:0.8rem">修改密码</span>
        </van-col>
      </van-row>
    </van-cell-group>
    <van-popup v-model="showPwd" position="bottom">
      <van-form @submit="onSubmit">
        <van-field v-model="pwd.oldPassword" type="password" clearable label="旧密码" required placeholder="请填写旧密码"
          :rules="[{ required: true }]" />
        <van-field v-model="pwd.newPassword" type="password" clearable label="新密码" required placeholder="请填写新密码"
          :rules="[{ required: true }]" />
        <van-field v-model="newPassword2" type="password" clearable label="确认密码" required placeholder="请填写确认密码"
          :rules="[{ required: true }]" />
        <div style="margin:1rem;">
          <van-button round block type="info" native-type="submit">提交</van-button>
        </div>
      </van-form>
    </van-popup>
  </div>
</template>
<script>
import { Toast } from "vant";
import { Dialog } from 'vant';
import { authorization } from '../authorization/authorization'
export default {
  data() {
    return {
      pwd: {
        oldPassword: "",
        newPassword: "",
      },
      newPassword2: "",
      showPwd: false,
      moduleOrderCounts: {},
      userName: localStorage.getItem("userName"),
      receivingOrder: localStorage.getItem("receivingOrder"),
      roleName: this.getRoleName(),
       orderList: [
        { type: -1, title: "我的订单", color: "#7af", icon: "orders-o", num: 0 },
        { type: 6, title: "待结算订单", color: "#fa0", icon: "balance-list-o", num: 0 },
        { type: 7, title: "已结算订单", color: "#f00", icon: "bill-o", num: 0 },

        // { type: 1, title: "待首联订单", color: "#7af", icon: "phone-circle-o", num: 0 },
        // { type: 9, title: "电表申请中", color: "#fa0", icon: "newspaper-o", num: 0 },
        { type: 2, title: "待安装订单", color: "#f00", icon: "todo-list-o", num: 0 },

        { type: 3, title: "待审核订单", color: "#7af", icon: "completed", num: 0 },
        { type: 4, title: "被驳回订单", color: "#fa0", icon: "failure", num: 0 },
        // { type: 5, title: "暂不安装订单", color: "#f00", icon: "description", num: 0 },
        { type: 16, title: "今日待安装", color: "#fa2", icon: "todo-list-o", num: 0 },
        // { type: 10, title: "等待客户通知", color: "#7af", icon: "description", num: 0 },
        // { type: 11, title: "取消待审核", color: "#fa0", icon: "description", num: 0 },
        { type: 15, title: "待上游审核", color: "#7af", icon: "completed", num: 0 },
        { type: 12, title: "已取消", color: "#f00", icon: "description", num: 0 },

        { type: -2, title: "维修单", color: "#7af", icon: "description", num: 0 },
        { type: -3, title: "自提单", color: "#fa0", icon: "description", num: 0 },
        // { type: 13, title: "待勘测订单", color: "#f00", icon: "todo-list-o", num: 0 },
      ],
      mamageList: [
        { type: 1, title: "订单管理", color: "#7af", icon: "records", isHidden: !authorization('/home-admin/order/order-manage') },
        { type: 3, title: "质保金", color: "#f00", icon: "gold-coin", isHidden: !authorization('/home-admin/routineManage/quality-deposit-h5') },
        { type: 2, title: "充电桩管理", color: "#fa0", icon: "desktop-o", isHidden: !authorization('/home-admin/device/device-manage') },
      ],
      settlementList: [
        { type: 3, title: "预结算列表", color: "#7af", icon: "todo-list-o",url:'/SettlementList',isHidden: authorization('/home-admin/settlementManage/h5/draft'),num: 0},
        { type: 0, title: "待确认结算单", color: "#7af", icon: "orders-o",url:'/SettlementList',isHidden: authorization('/home-admin/settlementManage/h5/pending'),num: 0},
        { type: 1, title: "付款中结算单", color: "#fa0", icon: "balance-list-o",url:'/SettlementList',isHidden: authorization('/home-admin/settlementManage/h5/unpaid'),num: 0},
        { type: 2, title: "已支付结算单", color: "#f00", icon: "bill-o",url:'/SettlementList',isHidden: authorization('/home-admin/settlementManage/h5/paid'),num: 0},
      ],
    };
  },
  computed: {
    orderSections() {
      const prioritizedOrders = [
        ...this.orderList.filter(item => item.type === 2),
        ...this.orderList.filter(item => item.type === 16),
        ...this.orderList.filter(item => item.type !== 2 && item.type !== 16),
      ];
      return [
        { title: '安装单', linkText: '查看全部', orderType: 1 },
        { title: '维修单', linkText: '查看全部', orderType: 2 },
        { title: '自提单', linkText: '查看全部', orderType: 3 },
      ].map(section => ({
        ...section,
        count: (this.moduleOrderCounts[section.orderType] || {}).totalCount || 0,
        items: prioritizedOrders.filter(item => ![-1, -2, -3].includes(item.type)
          && (section.orderType !== 3 || ![6, 7, 15, 3].includes(item.type))).map(item => ({
          ...item,
          title: section.orderType === 2 ? item.title.replace(/安装/g, '维修')
            : section.orderType === 3 ? item.title.replace(/安装/g, '自提') : item.title,
          num: (this.moduleOrderCounts[section.orderType] || {})[{
            2: 'beInstallCount', 16: 'beInstalledTodayCount', 6: 'beSettledCount',
            7: 'settledCount', 3: 'installCount', 4: 'rejectedCount', 15: 'beAuditedCount', 12: 'cancelCount',
          }[item.type]] || 0,
        })),
      }));
    },
  },
  created() {
    if (localStorage.getItem("token") === null || localStorage.getItem("token") === undefined) {
      this.$router.push('/Login')
    }
    this.getOrderCount()
    this.getSettlementCount()
  },
  methods: {
    authorization,
    getOrderCount() {
      if (!authorization('/order-data-manage')) return;
      [1, 2, 3].forEach(orderType => {
        this.axios({
          method: 'get',
          url: '/v1/h5/order-info/select-module-order-count',
          params: { orderType },
        }).then(res => {
          if (res.data.code === 200 && res.data.data) {
            this.$set(this.moduleOrderCounts, orderType, res.data.data);
          }
        }).catch(() => {});
      });
    },
    getSettlementCount() {
      this.axios({
        url:'/v1/web/settlement-manage/settlement-order/listStatusCountH5',
        method:'post'
      }).then(res=>{
        this.settlementList[0].num = res.data.data.draftCount
        this.settlementList[1].num = res.data.data.toBeConfirmedCount
        this.settlementList[2].num = res.data.data.paymentCount
        this.settlementList[3].num = res.data.data.paidCount
      })
    },
    onSubmit() {
      if (this.pwd.newPassword !== this.newPassword2) {
        Toast.fail('两次密码不一致');
      } else {
        this.axios({
          method: "post",
          url: "/v1/h5/user-info/update-password",
          data: this.pwd,
        }).then((res) => {
          if (res.data.code === 200) {
            this.showPwd = false;
            Toast.success('修改成功');
          } else {
            Toast.fail(res.data.message);
          }
        });
      }
    },
    getRoleName() {
      let roleList = JSON.parse(localStorage.getItem("roleList"));
      let resultName = ""
      for (let i = 0; i < roleList.length; i++) {
        if (i > 0) {
          resultName = resultName + ","
        }
        resultName = resultName + roleList[i].roleName
      }
      
      return resultName;
    },
    isShowReceivingOrder() {
      let roleList = JSON.parse(localStorage.getItem("roleList"));
      for (let i = 0; i < roleList.length; i++) {
        if (roleList[i].id === 3) {
          return true;
        }
      }
      return false;
    },
    goback() {//返回上一页
      this.$router.push('/Login');
    },
    goOrderList(type, orderType) {//跳转到订单页面
      this.$router.push({ path: '/OrderList', query: { type, orderType } });
    },
    goSettlementList(url,type) {//跳转到结算页面
      this.$router.push({ path: url, query: { type: type } });
    },
    goMamageList(type) {
      if (type == 1) {//跳转到订单管理页面
        this.$router.push('/OrderManage');
      } else if (type == 2) {//跳转到充电桩管理页面
        this.$router.push('/MyDevice');
      }else if(type == 3){
        this.$router.push({path:'/retention-money',query:{type: type}});
      }
    },
    isSetReceiving() {
      let message = this.receivingOrder == 0 ? "是否暂停接单" : "是否开始接单"
      Dialog.confirm({
        title: '接单设置',
        message: message,
      })
        .then(() => {
          // on confirm
          this.setOrderTaking()
        })
    },
    setOrderTaking() {
      let receivingOrder = this.receivingOrder == 0 ? 1 : 0
      this.axios({
        method: "post",
        url: "/v1/h5/user-info/set-order-taking",
        params: {
          receivingOrder: receivingOrder
        },
      }).then((res) => {
        if (res.data.code === 200) {
          Toast.success("设置成功");
          localStorage.setItem("receivingOrder", receivingOrder)
          this.receivingOrder = receivingOrder
        } else {
          Toast.fail(res.data.message);
        }
      })
    },
    loginOut() {
      Dialog.confirm({
        title: '退出登录',
        message: "是否确认退出",
      })
        .then(() => {
          this.axios({
            method: "post",
            url: "/v1/h5/user-info/login-out"
          }).then((res) => {
            if (res.data.code === 200) {
              Toast.success("退出成功");
              localStorage.removeItem("token")
              this.$router.push('/Login')
            } else {
              Toast.fail(res.data.message);
            }
          })
        })
    }
  },
};
</script>

<style scoped>
.home-order-section { margin: 12px 8px 0; border-radius: 12px; overflow: hidden; background: #fff; }
.home-order-divider { width: 64px; height: 3px; margin: 18px auto 6px; border-radius: 2px; background: #dcdfe6; }
.home-order-section /deep/ .van-cell { padding: 12px 14px; text-align: left; background: #fafbfc; }
.home-order-section /deep/ .van-cell__title { font-weight: 600; }
.home-order-section-1 /deep/ .van-cell { background: #f0f7ff; }
.home-order-title { display: inline-flex; align-items: center; gap: 8px; }
.home-order-count { display: inline-flex; align-items: center; justify-content: center; height: 20px; color: #1989fa96; font-size: 12px; font-weight: normal; line-height: 1; }
.home-order-section-3 /deep/ .van-cell { background: #fff8ef; }
.home-order-section-2 /deep/ .van-cell { background: #fff1f3; }
.home-order-section /deep/ .van-col { text-align: center; }
</style>
